import Layout from "../components/Layout";
import React, {useEffect, useState, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {Formik } from 'formik'
import TextField from "../components/TextField";
import axios from 'axios';
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import * as Yup from "yup";
import { Toast } from 'primereact/toast';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const MatrixLibrary = () => {
    const primeToast = useRef(null)
    const {user} = useSelector((state) => state["auth"]);
    const [isLoading,setIsLoading] = useState(false);
    const [enableForm,setEnableForm] = useState(true);
    const [userInformation,setUserInformation] = useState([]);
    const [matrixTitle,setMatrixTitle] = useState([]);
    const [userMatrixTitle,setUserMatrixTitle] = useState([]);
    const [filterValue, setFilterValue] = useState('');
    const [employeeName, setEmployeeName] = useState('');
    const [employeeRegisterID, setEmployeeRegisterID] = useState(0);
    const [matrixSelectedValue, setMatrixSelectedValue] = useState(0);
    const filterInputRef = useRef();

    const [userMatrixInformation, setUserMatrixInformation] = useState({
        registerID: employeeRegisterID,
        employeeWiseMatrixLibraryID: 0,
        matrixLibraryID: 0,
        AddedBy: user.registerID.toString()
    })
    useEffect(() => {
        initFilters();
        GetUserAndMatrixTitles();
    }, [enableForm])

    const GetUserAndMatrixTitles = () => {
        setIsLoading(true);
        axios.get(BASE_URL + "/api/MatrixLibrary/GetAllRegisteredUsers")
            .then(response => {                
                setUserInformation(response.data)
                setIsLoading(false);
            })
            .catch(console.error)
        
        setIsLoading(true);
        axios.get(BASE_URL + "/api/MatrixLibrary/GetAllMatrixTitle")
            .then(response => {
                setMatrixTitle(response.data)
                setIsLoading(false);
            })
            .catch(console.error)
    }

    const employeebody = ({registerID,employeeName}) => (        
        <a href="#" style={{textDecoration:"none"}} onClick={() => GetEmployeeMatrix(registerID,employeeName)} > {employeeName}</a>
        
    )

    const deleteMatrixBody = ({employeeWiseMatrixLibraryID}) => (
      <center>  
      <a href="#" className="btn btn-danger btnDelete" style={{textDecoration:"none", padding:"5px 15px 5px 15px !important"}} onClick={() => DeleteSelectedMatrixTitle(employeeWiseMatrixLibraryID)} > x</a>
      </center>
    )
    
    const DeleteSelectedMatrixTitle=(employeeWiseMatrixLibraryID)=>{
        const assItem = {
            employeeWiseMatrixLibraryID: employeeWiseMatrixLibraryID,
            AddedBy: user.registerID.toString()
        };

        axios.post(BASE_URL + "/api/MatrixLibrary/DeleteUserWiseMatrixTitle", JSON.stringify(assItem))
        .then(response => {
            if (response.status === 200) {
                LoadEmployeeMatrixData(employeeRegisterID);
                primeToast.current.show({
                    severity: 'info',
                    summary: 'success',
                    detail: 'Selected Matrix Title Deleted Successfully..!',
                    life: 3000
                });
            }
            else{
                primeToast.current.show({
                    severity: 'error',
                    summary: 'error',
                    detail: 'Selected Matrix Title Deleted Failed..!',
                    life: 3000
                });
            }
            setIsLoading(false);
        })
        .catch(e => {
            setIsLoading(false);
            console.log(e)
        })
    }

    const GetEmployeeMatrix = (id,Name) =>{
        setEmployeeRegisterID(id);
        setEmployeeName(Name);        
        LoadEmployeeMatrixData(id);        
    }
    const LoadEmployeeMatrixData=(id)=>{
        setIsLoading(true);
        setEnableForm(true);
        axios.post(BASE_URL + `/api/MatrixLibrary/GetUserMatrixTitle/${id}`)
            .then(response => {                
                setUserMatrixTitle(response.data)
                setEnableForm(false);
                setIsLoading(false);
            })
            .catch(console.error)
    }

    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue('');
    }

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const clearFilter = () => {
        initFilters();
    }

    const gridHeader = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );
    const onMatrixTitleSelect = (e) => {
        //const registerId = e.currentTarget.value
        console.log("Forhad ->"+ e.currentTarget.value);
    }

    const filterTemplate = (options) => {
        let {filterOptions} = options;
    
        return (
            <div className="flex gap-2">
                <InputText value={filterValue} ref={filterInputRef} onChange={(e) => myFilterFunction(e, filterOptions)} />
                <Button label="Reset" onClick={() => myResetFunction(filterOptions)} />
            </div>
        )
    }
    
    const myResetFunction = (options) => {
        setFilterValue('');
        options.reset();
        filterInputRef && filterInputRef.current.focus()
    }
    
    const myFilterFunction = (event, options) => {
        let _filterValue = event.target.value;
        setFilterValue(_filterValue);
        options.filter(event);
    }
    const ClearInformation=()=>{
        setEmployeeName('');
        setUserMatrixTitle([]);
        setEnableForm(true);
        setMatrixSelectedValue(0);
    }

    const onMatrixValueChange = (e) => {
        setMatrixSelectedValue(e.currentTarget.value);
    }

    const SaveUserMatrix=()=>{

            if(matrixSelectedValue < 0){
                primeToast.current.show({
                    severity: 'info',
                    summary: 'Warning',
                    detail: 'Please Select a Title..!',
                    life: 3000
                });

                return false;
            }

            const assItem = {
                registerID: employeeRegisterID,
                employeeWiseMatrixLibraryID: 0,
                matrixLibraryID: parseInt(matrixSelectedValue),
                AddedBy: user.registerID.toString()
            };

            axios.post(BASE_URL + "/api/MatrixLibrary/SaveUserWiseMatrixTitle", JSON.stringify(assItem))
            .then(response => {
                if (response.status === 200) {
                    LoadEmployeeMatrixData(employeeRegisterID);
                    //console.log(employeeRegisterID);
                    primeToast.current.show({
                        severity: 'info',
                        summary: 'success',
                        detail: 'Selected Matrix Title Added Successfully..!',
                        life: 3000
                    });
                }
                else{
                    primeToast.current.show({
                        severity: 'error',
                        summary: 'error',
                        detail: 'Selected Matrix Title Added Successfully..!',
                        life: 3000
                    });
                }
                setIsLoading(false);
            })
            .catch(e => {
                setIsLoading(false);
                console.log(e)
            })
    }

    return (<Layout>
        <Toast ref={primeToast}/>
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-person-plus"></i> User Wise Skill Library</h6>
            </div>
            <div className="card-body">
                <div className="card-header">
                    <div className="row">                    
                        <div className="col-5">
                            <select id="ddlTaskTitle" disabled={enableForm} onChange={onMatrixValueChange}
                            name="ddlTaskTitle" className="form-select"  filter showClear filterBy="matrixTitle"    
                                    aria-label=".form-select-sm example">
                                <option value={-1}>{"Select Skill Titles"}</option>
                                {matrixTitle.map((value, index) => <option key={index}
                                 value={value.matrixLibraryID}>{value.matrixTitle}</option>)}
                            </select>
                        </div>
                        <div className="col-2">
                            <button disabled={enableForm}  onClick={SaveUserMatrix} className="btn btn-primary"><i class="bi bi-plus-circle"></i> Add Skill Titles</button>
                        </div>
                        <div className="col-4 mt-2">
                            {employeeName.length > 0 ?
                            <span className="font-weight-bold"><i class="bi bi-person-lines-fill"></i> {employeeName} </span> : ""
                            }
                        </div>
                        <div className="col-1">
                        {employeeName.length > 0 ?
                            <button title="Cancel" onClick={ClearInformation} className="btn btn-success"><i class="bi bi-arrow-repeat"></i></button>:""
                        }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-7">
                        <DataTable value={userInformation}
                            header={gridHeader}
                            globalFilterFields={['employeeCode','employeeName','department','designation']}
                            filters={filters} 
                            filterDisplay="menu"
                            resizableColumns
                            showGridlines
                            dataKey="userRoleID"
                            paginator rows={10} first={1}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                                <Column field="registerID" header="registerID" hidden={true}/>
                                <Column field='employeeCode' sortable header="Code" />
                                <Column field='employeeName' sortable header="Name" body={employeebody} />
                                <Column field='department' sortable header="Department" />
                                <Column field='designation' sortable header="Designation" />                           
                            </DataTable>
                    </div>
                    <div className="col-5">
                    <DataTable value={userMatrixTitle} 
                            resizableColumns
                            showGridlines
                            dataKey="userRoleID"  filterDisplay="menu"
                            paginator rows={8} first={1}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                                <Column field='employeeWiseMatrixLibraryID' width="25%" header="Remove" body={deleteMatrixBody} />                                 
                                <Column field='matrixTitle' sortable header="Skill Titles" />
                            </DataTable>
                    </div>
                </div>
            </div>            
        </div>

    </Layout>)    
}

export default MatrixLibrary